import {useCallback, useState} from "react";

export const useCycleLanesToggleButton = (initialState: boolean) => {
    const [cycleLanesVisible, setCycleLanesVisible] = useState(initialState)

    const handleCycleLanesButtonLoad = useCallback((map: mapboxgl.Map) => {
        const enabledColor = "#5B9E94"
        const disabledColor = "#555555"
        const textColor = "#FFFFFF"

        const container = document.createElement('div')
        container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group'
        container.style.display = 'flex'
        container.style.alignItems = 'center'
        container.style.padding = '6px 8px'
        container.style.gap = '8px'
        container.style.backgroundColor = 'rgba(0, 0, 0, 0.4)'
        container.style.borderRadius = '6px'

        // Toggle label container
        const label = document.createElement('label')
        label.style.display = 'inline-block'
        label.style.position = 'relative'
        label.style.width = '40px'
        label.style.height = '20px'
        label.style.cursor = 'pointer'

        // Text node
        const textLabel = document.createElement('span')
        textLabel.innerText = 'Pistes cyclables'
        textLabel.style.fontSize = '14px'
        textLabel.style.userSelect = 'none'
        textLabel.style.color = textColor

        // Hidden checkbox
        const checkbox = document.createElement('input')
        checkbox.type = 'checkbox'
        checkbox.checked = cycleLanesVisible
        checkbox.style.display = 'none'

        // Slider track
        const slider = document.createElement('span')
        slider.style.position = 'absolute'
        slider.style.top = '0'
        slider.style.left = '0'
        slider.style.right = '0'
        slider.style.bottom = '0'
        slider.style.borderRadius = '24px'
        slider.style.transition = '0.3s'

        // Slider knob
        const knob = document.createElement('span')
        knob.style.position = 'absolute'
        knob.style.height = '16px'
        knob.style.width = '16px'
        knob.style.bottom = '2px'
        knob.style.backgroundColor = '#FFFFFF'
        knob.style.borderRadius = '50%'
        knob.style.transition = '0.3s'
        slider.appendChild(knob)

        const updateSliderStyles = () => {
            const isChecked = checkbox.checked
            slider.style.backgroundColor = isChecked ? enabledColor : disabledColor
            knob.style.left = isChecked ? '22px' : '2px'
        }
        updateSliderStyles()

        // Update on toggle
        checkbox.onchange = () => {
            const isChecked = checkbox.checked
            setCycleLanesVisible(isChecked)
            updateSliderStyles()
        }

        label.appendChild(checkbox)
        label.appendChild(slider)
        container.appendChild(label)
        container.appendChild(textLabel)

        map.addControl({
            onAdd: () => container,
            onRemove: () => container.parentNode?.removeChild(container)
        }, 'bottom-right')
    }, [cycleLanesVisible])

    return [cycleLanesVisible, handleCycleLanesButtonLoad] as const
}
